export default "__VITE_ASSET__YBZ6MmBW__"